const translations: Record<string, string> = {
  "site.name": "yoybuyspreadsheet",
  "site.tagline": "Удобная система заказов из Китая через таблицу",
  "nav.categories": "Категории",
  "nav.home": "На главную",
  "nav.yoybuy_sheet": "yoybuy sheet",
  "nav.buy_now": "buy it now",

  "hero.title": "YOYBUY Spreadsheet",
  "hero.subtitle": "Удобная система заказов из Китая через таблицу",
  "hero.description": "Автоматизированная система заказов через YOYBUY Spreadsheet помогает покупать на Taobao, 1688 и других китайских платформах без ошибок, переплат и путаницы.",
  "hero.cta_start": "Начать использовать YOYBUY Spreadsheet",
  "hero.cta_examples": "Смотреть примеры таблиц",

  "about.label": "Система заказов из Китая",
  "about.title_line1": "Покупайте из Китая",
  "about.title_line2": "без ошибок и переплат",
  "about.title_line3": "с YOYBUY Spreadsheet",

  "why.title": "Почему обычные заказы из Китая сложны?",
  "why.item1_title": "Непонятные цены",
  "why.item1_desc": "На Taobao и 1688 сложно сразу понять итоговую стоимость товара с учётом всех комиссий.",
  "why.item2_title": "Ошибки при заказе",
  "why.item2_desc": "При ручном заполнении данных легко ошибиться в артикулах, цветах и размерах.",
  "why.item3_title": "Потеря данных",
  "why.item3_desc": "Вся переписка в чатах теряется, а история заказов становится недоступной.",
  "why.item4_title": "Сложный расчёт доставки",
  "why.item4_desc": "Без структурированной таблицы невозможно точно спланировать стоимость доставки.",

  "solution.title": "Что такое YOYBUY Spreadsheet?",
  "solution.desc": "YOYBUY Spreadsheet — это структурированная таблица заказов, которая позволяет управлять всеми покупками в одном месте, автоматически отслеживать товары, снижать ошибки и упрощать работу с агентом YOYBUY.",
  "solution.feature1": "Управление заказами в одном месте",
  "solution.feature2": "Автоматическое отслеживание товаров",
  "solution.feature3": "Снижение ошибок при покупке",
  "solution.feature4": "Упрощение работы с агентом",

  "categories.title": "Популярные категории",
  "categories.subtitle": "Выбирайте товары по категориям и оформляйте заказы через YOYBUY Spreadsheet",
  "categories.all": "Все категории",

  "testimonial.quote": "YOYBUY Spreadsheet полностью изменил мой подход к заказам из Китая. Раньше я тратил часы на переписку и постоянно ошибался. Теперь весь процесс занимает несколько минут, а ошибки практически исключены.",
  "testimonial.name": "Алексей Петров",
  "testimonial.role": "Владелец интернет-магазина",
  "testimonial.cta": "Смотреть пример таблицы",

  "comparison.title": "YOYBUY Spreadsheet vs обычный способ заказов",
  "comparison.col1": "Spreadsheet",
  "comparison.col2": "Чат-заказы",
  "comparison.row1_label": "Ошибки",
  "comparison.row1_yes": "Минимальные",
  "comparison.row1_no": "Частые",
  "comparison.row2_label": "Скорость",
  "comparison.row2_yes": "Быстрая",
  "comparison.row2_no": "Медленная",
  "comparison.row3_label": "Контроль",
  "comparison.row3_yes": "Полный",
  "comparison.row3_no": "Ограниченный",
  "comparison.row4_label": "Отслеживание",
  "comparison.row4_yes": "Автоматическое",
  "comparison.row4_no": "Ручное",

  "related.title": "Другие популярные системы",
  "related.kakobuy": "Kakobuy Spreadsheet система заказов",
  "related.superbuy": "Superbuy Spreadsheet инструкция",
  "related.compare": "Сравнение YOYBUY vs Superbuy vs Kakobuy",
  "related.cta": "Сравнить сейчас",

  "trust.title": "Почему нам доверяют",
  "trust.item1": "Проверка товаров на складе",
  "trust.item2": "Фото перед отправкой",
  "trust.item3": "Защита платежей",
  "trust.item4": "Возврат средств при ошибке",

  "faq.title": "Часто задаваемые вопросы",
  "faq.q1": "Что такое YOYBUY Spreadsheet?",
  "faq.a1": "YOYBUY Spreadsheet — это структурированная система заказов в виде таблицы, которая позволяет удобно управлять всеми покупками из Китая через одного агента. Вы просто заполняете таблицу ссылками на товары, а система автоматически отслеживает статус каждого заказа.",
  "faq.q2": "Как использовать spreadsheet систему?",
  "faq.a2": "Просто скопируйте ссылку на товар с Taobao или 1688, вставьте её в таблицу YOYBUY, укажите количество и характеристики. Агент обработает заказ и сообщит о статусе.",
  "faq.q3": "YOYBUY безопасен?",
  "faq.a3": "Да, YOYBUY обеспечивает проверку товаров на складе, делает фото перед отправкой и предлагает защиту платежей. При обнаружении брака возможен возврат средств.",
  "faq.q4": "Чем отличается от Superbuy?",
  "faq.a4": "YOYBUY Spreadsheet предлагает более простую и интуитивную систему таблиц, специально оптимизированную для новичков. В отличие от Superbuy, интерфейс YOYBUY минималистичен и не перегружен лишними функциями.",
  "faq.q5": "Можно ли использовать без опыта?",
  "faq.a5": "Абсолютно! YOYBUY Spreadsheet разработан специально для тех, кто никогда раньше не заказывал из Китая. Пошаговая система и поддержка агента помогут вам с первым заказом.",

  "cta.title": "Начните использовать YOYBUY Spreadsheet уже сегодня",
  "cta.subtitle": "Упростите покупки из Китая с нашей системой таблиц",
  "cta.button": "BUY IT NOW",

  "footer.address": "Адрес",
  "footer.phone": "Телефон",
  "footer.email": "Email",
  "footer.copyright": "© 2026 yoybuyspreadsheet.cyou. Все права защищены.",
  "footer.home": "Главная",
  "footer.article": "Руководство по YOYBUY Spreadsheet",

  "article.title": "Полное руководство по YOYBUY Spreadsheet: как заказывать из Китая без ошибок",
  "article.meta": "Опубликовано: 4 июля 2026",
  "article.summary": "Узнайте, как использовать YOYBUY Spreadsheet для эффективных заказов из Китая. Пошаговое руководство, советы и сравнение с другими системами.",
  "article.back_home": "← Вернуться на главную",

  "category.shoes": "Shoes",
  "category.hoodies": "Hoodies/Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants": "Pants/Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear/Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "Other Stuff",
};

export default translations;